import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faReact,
  faNodeJs,
  faHtml5,
  faCss3,
  faGitAlt,
  faSquareJs,
  faSalesforce, // Import the Salesforce icon
  faSass, // Import Sass icon
  faJira, // Import Jira icon
  faConfluence, // Import Confluence icon
  faGithub, // Import GitHub icon
  faBootstrap // Import Bootstrap icon
} from '@fortawesome/free-brands-svg-icons';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import '../App.css';

function Skills({ id }) {
  return (
    <section id={id}>
      <h2>Skills</h2>
      <ul className="skills-list">
        <li>
          <FontAwesomeIcon icon={faSalesforce} className="skill-logo" /> {/* Add the Salesforce icon */}
        </li>
        <li>
          <FontAwesomeIcon icon={faSquareJs} className="skill-logo" />
        </li>
        <li>
          <FontAwesomeIcon icon={faReact} className="skill-logo" />
        </li>
        <li>
          <FontAwesomeIcon icon={faNodeJs} className="skill-logo fa-node-js" />
        </li>
        <li>
          <FontAwesomeIcon icon={faHtml5} className="skill-logo" />
        </li>
        <li>
          <FontAwesomeIcon icon={faCss3} className="skill-logo" />
        </li>
        <li>
          <FontAwesomeIcon icon={faSass} className="skill-logo" /> {/* Add Sass icon */}
        </li>
        <li>
          <FontAwesomeIcon icon={faBootstrap} className="skill-logo" /> {/* Add Bootstrap icon */}
        </li>
        <li>
          <FontAwesomeIcon icon={faGitAlt} className="skill-logo" />
        </li>
        <li>
          <FontAwesomeIcon icon={faGithub} className="skill-logo" /> {/* Add GitHub icon */}
        </li>
        <li>
          <FontAwesomeIcon icon={faConfluence} className="skill-logo" /> {/* Add Confluence icon */}
        </li>
        <li>
          <FontAwesomeIcon icon={faJira} className="skill-logo" /> {/* Add Jira icon */}
        </li>
        <li>
          <FontAwesomeIcon icon={faDatabase} className="skill-logo" /> {/*MySQL has not icon*/}
        </li>
      </ul>
    </section>
  );
}

export default Skills;
